import { put, takeLatest } from "redux-saga/effects";
import { requestSubAgreementList 
    ,requestCreateSubAgreement, requestUpdateSubAgreement
} from "services/manage-property/property-agreement/subAgreement";

import {
  fetchSubAgreementListRequest,
  fetchSubAgreementListSuccess,
  fetchSubAgreementListFailure,

  createSubAgreementRequest,
  createSubAgreementSuccess,
  createSubAgreementFailure,
  updateSubAgreementRequest,
  updateSubAgreementSuccess,
  updateSubAgreementFailure
} from "../../../../redux/actions/manage-property/property-agreement/subAgreement-details";

import {
  FETCH_SUB_AGREEMENT_LIST_REQUEST,
  FETCH_SUB_AGREEMENT_LIST_SUCCESS,
  FETCH_SUB_AGREEMENT_LIST_FAILURE,
  CREATE_SUB_AGREEMENT_REQUEST,
  UPDATE_SUB_AGREEMENT_REQUEST
} from "../../../../redux/actions/manage-property/property-agreement/types";

export function* watchSubAgreementListSaga() {
  yield takeLatest(FETCH_SUB_AGREEMENT_LIST_REQUEST, fetchSubAgreement);
  yield takeLatest(CREATE_SUB_AGREEMENT_REQUEST, createSubAgreement);
  yield takeLatest(UPDATE_SUB_AGREEMENT_REQUEST, updateSubAgreement);
}

function* fetchSubAgreement({ payload }) {
  try {
    /**
     * @type {FetchBrokerFirmsResponse}
     */
    const response = yield requestSubAgreementList(payload);
    yield put(fetchSubAgreementListSuccess(response));
  } catch (error) {
    yield put(fetchSubAgreementListFailure("Failed to get Sub Agreement list"));
  }
}



/**
 *
 * @param {PARAMS} param0
 */
 function* createSubAgreement({ payload }) {
  try {
      const response = yield requestCreateSubAgreement(payload);
      yield put(createSubAgreementSuccess(response.data));
  } catch (error) {
      yield put(
        createSubAgreementFailure('Failed to create Sub Agreement')
      );
  }
}

/**
*
* @typedef {Object} BrokerFirmUpdatePayload
* @property {BrokerFirm} payload
*
* @param {BrokerFirmUpdatePayload} param0
*/
function* updateSubAgreement({ payload }) {
  try {
    const response =  yield requestUpdateSubAgreement(payload);
      yield put(updateSubAgreementSuccess(response.data));
  } catch (error) {
      yield put(
        updateSubAgreementFailure('Failed to update Sub Agreement')
      );
  }
}